import { isEqual, mapValues } from 'lodash';
import { keys } from '../../../ts-utils';
export const initDevToolsStore = ({ onChange, isDebug, wixCodeApi, }) => {
    const defaultValues = {
        panelIsOpenForResource: null,
        showLiveCommentsButton: 'auto',
        showSomeoneIsTyping: 'auto',
        showLoadMoreComments: 'auto',
        specialStates: 'none',
        language: undefined,
        crudState: { type: 'NO_MODIFICATION' },
        fetchState: { type: 'NO_MODIFICATION' },
        showContainerBorder: false,
        forceShowCommentBoxes: false,
        isLocked: 'auto',
        hideHeader: 'auto',
        hideTitle: 'auto',
        hideReplyingTo: 'auto',
        hideBadge: 'auto',
        hideAvatars: 'auto',
        hidePublishDate: 'auto',
        hideHeaderDivider: 'auto',
        hideSorting: 'auto',
        hideZeroCommentsEmptyState: 'auto',
        blackAndWhiteModals: 'auto',
        commentReactions: 'auto',
        replyReactions: 'auto',
        markLabels: 'auto',
        commentBoxPosition: 'auto',
        showReportAction: 'auto',
        ratings: { type: 'auto' },
    };
    let state = isDebug
        ? (() => {
            if (!wixCodeApi.location.query.wcDevToolsState) {
                return defaultValues;
            }
            try {
                const stateFromQuery = JSON.parse(decodeURIComponent(wixCodeApi.location.query.wcDevToolsState));
                return mapValues(defaultValues, (defaultValue, key) => {
                    const savedValue = stateFromQuery[key];
                    return savedValue === undefined ? defaultValue : savedValue;
                });
            }
            catch {
                return defaultValues;
            }
        })()
        : // No syncing in non-debug mode to not confuse users
            defaultValues;
    const syncToQuery = () => {
        if (!isDebug) {
            return;
        }
        const diff = keys(defaultValues).reduce((acc, key) => {
            if (!isEqual(defaultValues[key], state[key])) {
                // @ts-expect-error
                acc[key] = state[key];
            }
            return acc;
        }, {});
        if (keys(diff).length === 0) {
            wixCodeApi.location.queryParams.remove(['wcDevToolsState']);
        }
        else {
            wixCodeApi.location.queryParams.add({
                wcDevToolsState: encodeURIComponent(JSON.stringify(diff)),
            });
        }
    };
    const set = (key, value) => {
        state = {
            ...state,
            [key]: value,
        };
        syncToQuery();
        onChange(state);
    };
    return {
        set,
        reset: (key) => {
            state = {
                ...state,
                [key]: defaultValues[key],
            };
            syncToQuery();
            onChange(state);
        },
        resetAll: () => {
            keys(defaultValues).forEach((key) => {
                if (key === 'panelIsOpenForResource') {
                    return;
                }
            });
            state = { ...defaultValues, panelIsOpenForResource: state.panelIsOpenForResource };
            syncToQuery();
            onChange(state);
        },
        breakCrud: (delayInSeconds, status = 500, response) => set('crudState', { type: 'BROKEN', delay: delayInSeconds, status, response }),
        delayCrud: (delayInSeconds) => set('crudState', { type: 'DELAYED', delay: delayInSeconds }),
        fixCrud: () => set('crudState', { type: 'NO_MODIFICATION' }),
        breakFetch: (delayInSeconds, status = 500) => set('fetchState', { type: 'BROKEN', delay: delayInSeconds, status }),
        delayFetch: (delayInSeconds) => set('fetchState', { type: 'DELAYED', delay: delayInSeconds }),
        fixFetch: () => set('fetchState', { type: 'NO_MODIFICATION' }),
        invokeAppCrash: () => set('specialStates', 'crash'),
        getState: () => {
            return state;
        },
    };
};
//# sourceMappingURL=init-dev-tool-store.js.map